import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { GrowthConsole } from './pages/GrowthConsole';
import { DealerDashboard } from './pages/DealerDashboard';
import { MasterCreativeEditing } from './pages/MasterCreativeEditing';
import { CampaignSetup } from './pages/CampaignSetup';
import { CreativeSelection } from './pages/CreativeSelection';
import { StylingTemplate } from './pages/StylingTemplate';
import { VariableContent } from './pages/VariableContent';
import { GenerateCreatives } from './pages/GenerateCreatives';
import { ReviewPublish } from './pages/ReviewPublish';
import { DealerCreativeDashboard } from './pages/dealer/DealerCreativeDashboard';
import { SelectCarModel } from './pages/dealer/SelectCarModel';
import { ChooseBackground } from './pages/dealer/ChooseBackground';
import { AddGreetings } from './pages/dealer/AddGreetings';
import { AddDealerInfo } from './pages/dealer/AddDealerInfo';
import { GenerateCreative } from './pages/dealer/GenerateCreative';
import { ChooseOutputFormat } from './pages/dealer/ChooseOutputFormat';
import { ResizerUpload } from './pages/dealer/ResizerUpload';
import { ResizerFormats } from './pages/dealer/ResizerFormats';
import { VideoUpload } from './pages/dealer/video-generator/VideoUpload';
import { VideoConfiguration } from './pages/dealer/video-generator/VideoConfiguration';
import { VideoGeneration } from './pages/dealer/video-generator/VideoGeneration';
import { VideoPreview } from './pages/dealer/video-generator/VideoPreview';
import { LeadsManagement } from './pages/LeadsManagement';
import { Conversations } from './pages/Conversations';
import { Workflows } from './pages/Workflows';
import { Settings } from './pages/Settings';
export function AppRouter() {
  return <BrowserRouter data-id="element-8">
      <Routes data-id="element-9">
        <Route path="/" element={<App data-id="element-11" />} data-id="element-10" />

        {/* Growth Console Route */}
        <Route path="/growth-console" element={<GrowthConsole data-id="element-13" />} data-id="element-12" />

        {/* Campaigns Route */}
        <Route path="/campaigns" element={<App data-id="element-15" />} data-id="element-14" />

        {/* Leads Management Route */}
        <Route path="/leads" element={<LeadsManagement data-id="element-17" />} data-id="element-16" />

        {/* New Routes */}
        <Route path="/conversations" element={<Conversations data-id="element-19" />} data-id="element-18" />
        <Route path="/workflows" element={<Workflows data-id="element-21" />} data-id="element-20" />

        {/* Settings Routes with nested routes */}
        <Route path="/settings/*" element={<Settings data-id="element-23" />} data-id="element-22" />

        {/* Dealerization Flow Routes */}
        <Route path="/dealerization" element={<DealerDashboard data-id="element-25" />} data-id="element-24" />
        <Route path="/dealerization/step-0" element={<MasterCreativeEditing data-id="element-27" />} data-id="element-26" />
        <Route path="/dealerization/step-1" element={<CampaignSetup data-id="element-29" />} data-id="element-28" />
        <Route path="/dealerization/step-2" element={<CreativeSelection data-id="element-31" />} data-id="element-30" />
        <Route path="/dealerization/step-3" element={<StylingTemplate data-id="element-33" />} data-id="element-32" />
        <Route path="/dealerization/step-4" element={<VariableContent data-id="element-35" />} data-id="element-34" />
        <Route path="/dealerization/step-5" element={<GenerateCreatives data-id="element-37" />} data-id="element-36" />
        <Route path="/dealerization/step-6" element={<ReviewPublish data-id="element-39" />} data-id="element-38" />

        {/* Creative Customizer Routes */}
        <Route path="/creative-customizer" element={<DealerCreativeDashboard data-id="element-41" />} data-id="element-40" />
        <Route path="/dealer/creative-customizer" element={<DealerCreativeDashboard data-id="element-43" />} data-id="element-42" />

        {/* AI Creative Generator Flow */}
        <Route path="/dealer/ai-generator/step-1" element={<SelectCarModel data-id="element-45" />} data-id="element-44" />
        <Route path="/dealer/ai-generator/step-2" element={<ChooseBackground data-id="element-47" />} data-id="element-46" />
        <Route path="/dealer/ai-generator/step-3" element={<AddGreetings data-id="element-49" />} data-id="element-48" />
        <Route path="/dealer/ai-generator/step-4" element={<AddDealerInfo data-id="element-51" />} data-id="element-50" />
        <Route path="/dealer/ai-generator/step-5" element={<GenerateCreative data-id="element-53" />} data-id="element-52" />
        <Route path="/dealer/ai-generator/step-6" element={<ChooseOutputFormat data-id="element-55" />} data-id="element-54" />

        {/* Creative Resizer Flow */}
        <Route path="/dealer/resizer/step-1" element={<ResizerUpload data-id="element-57" />} data-id="element-56" />
        <Route path="/dealer/resizer/step-2" element={<ResizerFormats data-id="element-59" />} data-id="element-58" />

        {/* Image to Video Generator Flow */}
        <Route path="/dealer/video-generator/upload" element={<VideoUpload data-id="element-61" />} data-id="element-60" />
        <Route path="/dealer/video-generator/configure" element={<VideoConfiguration data-id="element-63" />} data-id="element-62" />
        <Route path="/dealer/video-generator/generate" element={<VideoGeneration data-id="element-65" />} data-id="element-64" />
        <Route path="/dealer/video-generator/preview" element={<VideoPreview data-id="element-67" />} data-id="element-66" />
      </Routes>
    </BrowserRouter>;
}